import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import type { ResourceSection as ResourceSectionType } from "./types";

interface LinkSectionProps {
  onClick?: () => void;
  section: ResourceSectionType;
}

export const LinkSection = ({
  section: { icon, title, description, iconAlt, link, onClick },
}: LinkSectionProps) => (
  <a href={link} target="_blank" rel="noopener noreferrer" onClick={onClick}>
    <div className="flex flex-row items-start gap-x-4 sm:items-center">
      <div>
        <img src={icon} loading="lazy" alt={iconAlt} className="size-10" />
      </div>
      <div className="w-full">
        <div className="flex flex-row justify-between">
          <Typography.TitleSm
            weight="semibold"
            size="text-sm"
            color="text-dark"
            leading="leading-5"
          >
            {title}
          </Typography.TitleSm>
          {link && (
            <Icon
              type="arrow-top-right"
              size={16}
              className="text-light"
              color="text-light"
              useWithFillCurrentColor
              useWithStrokeCurrentColor
            />
          )}
        </div>
        <Typography.BodySm weight="normal" size="text-sm" color="text-default">
          {description}
        </Typography.BodySm>
      </div>
    </div>
  </a>
);
